import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * Scroll to top on every route change. React Router preserves the scroll
 * position by default, which is unwanted for a multi-page app like ours.
 *
 * If the URL has a hash (#anchor), scroll to that element instead so deep
 * links continue to work (e.g. /admin#refunds).
 */
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      // Wait one frame so the target page has rendered the anchor element.
      requestAnimationFrame(() => {
        const el = document.getElementById(hash.replace("#", ""));
        if (el) {
          el.scrollIntoView({ behavior: "smooth", block: "start" });
          return;
        }
        window.scrollTo(0, 0);
      });
    } else {
      // Instant scroll — smooth on full page change feels sluggish.
      window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    }
  }, [pathname, hash]);

  return null;
}
